import { FC, useRef, useState } from "react";
import { Link } from "react-router";
import { useSelector } from "react-redux";
import classNames from "classnames";
import OutsideClickHandler from "../OutsideClickHandler/OutsideClickHandler";

import { ITopNavProps } from "./types";
import { BackLinkIcon } from "../icons/BackLinkIcon";
import { selectAuthIsTrial } from "../../store/selectors/auth";
import Trial from "./Components/Trial/Trial";
import Setting from "./Components/Setting/Setting";
import Menu from "../Menu/Menu";
import useResponsive from "../../hooks/useResponsive";
import Config from "../Sidebar/Components/Config/Config";
import Supermode from "./Components/Supermode/Supermode";
import AgencyClientMode from "./Components/AgencyClientMode/AgencyClientMode";
import { selectSuperuserSupermode } from "../../store/selectors/superuser";
import { selectAuthActingAsClientId } from "../../store/selectors/auth";

import styles from "./TopNav.module.css";



const TopNav: FC<ITopNavProps> = ({ title, linkBack, rightContent }) => {
  const { isDesktop } = useResponsive();
  const isTrial = useSelector(selectAuthIsTrial);
  const supermode = useSelector(selectSuperuserSupermode);
  const actingAsClientId = useSelector(selectAuthActingAsClientId);
  const ignoreRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleOutsideClick = (e: MouseEvent | TouchEvent) => {
    const target = e.target as Node | null;
    if (ignoreRef.current && target && ignoreRef.current.contains(target)) {
      return;
    }
    setIsOpen(false);
  };

  const renderMenuBurger = () => {
    return <button
      ref={ignoreRef}
      className={classNames(styles["topnav__burger"], isOpen && styles["is-open"])}
      onClick={() => setIsOpen(!isOpen)}>
      <span></span>
      <span></span>
      <span></span>
    </button>
  }

  const renderDefaultRightContent = () => {
    return <div className={styles["topnav__right"]}>
      <Setting />
    </div>;
  };

  const renderMenu = () => {
    return (
      <OutsideClickHandler onOutsideClick={handleOutsideClick}>
        <div className={styles["topnav__menu"]}>
          <Config />
          <Menu />
        </div>
      </OutsideClickHandler>
    );
  };

  return (
    <header className={styles["topnav"]}>
      <div className={styles["topnav__wrap"]}>
        <div className={styles["topnav__title"]}>
          {!isDesktop && renderMenuBurger()}
          {linkBack && (
            <Link className={styles["topnav__backlink"]} to={linkBack}>
              <BackLinkIcon />
            </Link>
          )}
          {isOpen && renderMenu()}
          <p>{title}</p>
        </div>

        {rightContent || renderDefaultRightContent()}
      </div>
      {isTrial && <Trial />}
      {supermode && <Supermode />}
      {!supermode && actingAsClientId && <AgencyClientMode />}
    </header >
  );
};

export default TopNav;
